/** SDK version — auto-referenced by collectors. */
export const SDK_VERSION = "2.0.0";
